var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackMountains(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 3959.032,
    height: 830.661,
    viewBox: "0 0 3959.032 830.661",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#122b40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#071e2c"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M-55.5,426.994S-7.846,1.007,72.422-.59c80.566-1.6,46.83,43.495,134.366,43.495s72.383,162.3,183.861,162.3c89.332,0,79.045-35.068,150.234-35.068S616.8,378.288,682.573,378.288c52.46,0,73.46-101.792,150.659-101.792s62.874-50.833,115.723-50.833c29.278,0,80.9-171.783,155.845-171.783s95.537,285.827,189.945,285.827c72.506,0,82.3-100.527,164.18-98.732,98.5,1.471,113.744-257.9,183.61-261.574s55.153,109.716,169.448,109.716c95.672,0,88.619,182.085,167.342,179.067,78.437-3.008,64.37-126.442,191.933-121.473s93.494,80.994,204.037,80.994c118.757,0,129.7,202.309,259.684,202.309,172.289,0,124.245-382.448,327.805-382.448,83.223,0,73.769-58.219,128.4-58.219,112.3,0,92.72,318.806,223.493,318.806,78.246,0,65.767-148.2,159.412-148.2,62.4,0,63.269,56.183,116.782,56.183,80.153,0,126.151-226.786,186.787-226.786s125.879,88.117,125.879,88.117V805.582l-3958,4.393Z",
    transform: "translate(55.499 20.686)",
    fill: "url(#linear-gradient)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackMountains);
export default __webpack_public_path__ + "static/media/back_mountains.f68f136d7c6de7901db5d593055dfa27.svg";
export { ForwardRef as ReactComponent };